import LeftBottom from "./LeftBottom";
import RightTop from "./RightTop";
import RightBottom from "./RightBottom";
import LeftTop from "./LeftTop";
import './desktop.css'

export default function Desktop(){
    return (
        <>
            <LeftTop />
            <LeftBottom />
            <RightTop />
            <RightBottom />
        </>
    )
}